import { Slide } from "react-slideshow-image";
import { ReactComponent as Discount } from "../../assets/home/hero/discount.svg";
import Sofa from "../../assets/home/hero/hero-section-sofa.png";
import Light from "../../assets/home/hero/light.png";
import Button from "../Button";
import { useNavigate } from "react-router-dom";

export default function Hero() {
  return (
    <Slide
      duration={3000}
      transitionDuration={300}
      autoplay={false}
      arrows={false}
      indicators={() => <div className="hero-indicator"></div>}
    >
      {/* slide 1 */}
      <Slide1 />
      <Slide1 />
      <Slide1 />
    </Slide>
  );
}

function Slide1() {
  const navigate = useNavigate();

  return (
    <div className="contianer h-[35rem] bg-[#F2F0FF] flex pl-16 pr-32 container mx-auto">
      {/* left side */}
      <div className=" flex-1 h-full flex ">
        {/* light container */}
        <div>
          <img src={Light} alt="" className=" w-72" />
        </div>
        {/* texts container */}
        <div className="flex flex-col justify-center items-start -ml-6">
          <div className=" font-fontTwo mb-4">
            <p className=" text-pink">Best Furniture For Your Castle...</p>
            <h2 className=" font-fontOne text-5xl font-bold my-2">
              New Furniture Collection Trends in 2020
            </h2>
            <p className=" text-sub_text_color">
              Aliqua duis pariatur et dolore. Eu do anim labore ea sint et et
              voluptate ipsum deserunt. Dolore est ullamco id tempor enim sit id
              aliquip incididunt duis.
            </p>
          </div>
          <Button color="pink" onClick={() => navigate("shopgrid")}>
            Shop Now
          </Button>
        </div>
      </div>
      {/* right side */}
      <div className=" flex justify-center items-center relative">
        <Discount className=" absolute w-24 top-8 right-8 z-10" />
        <div className=" bg-[rgba(236,210,250,.35)] rounded-full w-[28rem] -translate-x-4 translate-y-6">
          <div className="bg-[rgba(236,210,250,.35)] rounded-full p-6 translate-x-10 -translate-y-8">
            <img src={Sofa} alt="" className="-translate-x-6 translate-y-8" />
          </div>
        </div>
      </div>
    </div>
  );
}
